import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { SITE } from "@/data/site";

export default function CTAPanel({
  title = "Ready to Fix What's Bugging You About Your Home?",
  subtitle = "Tell us what you're dreaming of. We'll give you a clear, no-pressure quote — and an honest plan to get there.",
}) {
  return (
    <section data-testid="cta-panel" className="container-x py-16 md:py-24">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="relative overflow-hidden rounded-[28px] bg-brand-orange px-7 py-14 md:px-16 md:py-20 text-center"
      >
        {/* decorative */}
        <div className="pointer-events-none absolute -top-20 -right-16 h-64 w-64 rounded-full bg-white/10" />
        <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-black/5" />

        <div className="relative">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/80">Free Quote · No Obligation</p>
          <h2 className="mt-4 font-extrabold tracking-tight text-3xl md:text-5xl text-white leading-[1.08] max-w-3xl mx-auto">
            {title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-white/90 max-w-2xl mx-auto leading-relaxed">{subtitle}</p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-panel-quote-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-dark px-8 py-4 text-sm font-bold uppercase tracking-[0.04em] text-white transition-all duration-300 hover:bg-brand-darker hover:scale-[1.03] active:scale-95"
            >
              Get Your Free Quote <ArrowRight size={17} />
            </Link>
            <a
              href={SITE.phoneHref}
              data-testid="cta-panel-call-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/60 px-8 py-4 text-sm font-bold uppercase tracking-[0.04em] text-white transition-all duration-300 hover:bg-white hover:text-brand-orange hover:scale-[1.03] active:scale-95"
            >
              <Phone size={16} /> {SITE.phoneDisplay}
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
